import { Form, Formik, Field } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import UIModal from "../../../../../shared/components/UIModal";
import ToggleSwitch from "../../../../../shared/components/ToggleSwitch";
import UploadLogo from "../../../../../shared/components/UploadLogo";
import InputField from "../../../../../shared/components/InputField";
import DropdownField from "../../../../../shared/components/DropdownField";
import faker from "faker";
import "./instituteSectionForm.scss";
import { Col, Row, TreeSelect, Checkbox } from "antd";
import { SearchInput } from "../../../../../shared/components/SearchInput";
import {
  SectionExamMetaModel,
  Sections,
  SectionSubjectMetaModel,
} from "../../../../../models/InstituteModel/sections.model";
import { ClassRoomSubjectModel } from "../../../../../models/CourseModels/SubjectModel/subject.model";
import { ExamModel } from "../../../../../models/ExamModels/exam.model";
import SubjectService from "../../../../../services/CourseServices/SubjectService/subject.service";
import SectionService from "../../../../../services/InstituteService/section.service";
import {
  BranchClassRoomsModel,
  BranchMetaModel,
} from "../../../../../models/InstituteModel/branches.model";
import BranchService from "../../../../../services/InstituteService/branch.service";
import { ExamService } from "../../../../../services/ExamService/exam.service";
import { deserialize, serialize } from "serializr";
import {
  InstituteValidationSchema,
  SectionValidationSchema,
} from "../../../instituteFormValidation";
import { Institutes } from "../../../../../models/InstituteModel/institutes.model";
import { useLocation } from "react-router-dom";
const { TreeNode } = TreeSelect;

interface InstituteSectionFormProps {
  visible: boolean;
  closeHandler: () => void;
  data: Sections;
  refreshList: () => void;
}
const InstituteSectionForm: FC<InstituteSectionFormProps> = ({
  visible,
  closeHandler,
  data,
  refreshList,
}) => {
  const [initialValues, setInitialValues] = useState<any>({});
  const [branchClassRooms, setBranchClassRooms] = useState<any>();
  const [branches, setBranches] = useState<any>();
  const [subjects, setSubjects] = useState<ClassRoomSubjectModel[]>([]);
  const [exams, setExams] = useState<ExamModel[]>([]);
  const formRef = useRef<any>();
  const [subjectsHolder, setSubjectsHolder] = useState<any>();
  const [examsHolder, setExamsHolder] = useState<any>();
  const { state }: { state: Institutes } = useLocation();
  const [buttonLoading, setButtonLoading] = useState(false);

  useEffect(() => {
    fetchBranches({});
    fetchExams();
    setInitialValues({
      name: data?.name,
      isActive: data ? data?.isActive : true,
      branchId: data?.branch?.id,
      branchClassRoomId: data?.branchClassRoom?.id,
      sectionSubjects: data?.classRoomSubjects || [],
      sectionExams: data?.exams || [],
    });
    if (data) {
      fetchClassRooms(data?.branch?.id);
      fetchSubjects(data?.classRoom?.id);
    }
  }, [data, visible]);

  const fetchClassRooms = (id: any) => {
    SectionService.fetchBranchClassRooms(
      { branch_id: id },
      (classrooms: BranchClassRoomsModel[]) => {
        let meta: any = [];
        classrooms?.map((value, index) => {
          meta.push({
            label: value?.name,
            value: value?.id,
            id: value?.classRoom?.id,
          });
        });

        setBranchClassRooms([...meta]);
      },
      () => {},
      () => {}
    );
  };

  const fetchBranches = (params: any) => {
    BranchService.fetchBranches(
      { ...params, institute_id: state?.id },
      (data) => {
        let meta: any = deserialize(BranchMetaModel, data);
        setBranches([...meta]);
      },
      () => {},
      () => {}
    );
  };
  const fetchSubjects = (id: any) => {
    let queryParams = `?class_room_id=${id}`;

    SubjectService.getClassroomSubjectsList(
      queryParams,
      (subjects: any, pageMeta: any) => {
        setSubjects([...subjects]);
        setSubjectsHolder([...subjects]);
      },
      () => {},
      () => {}
    ).then();
  };

  const fetchExams = () => {
    ExamService.fetchExams(
      "",
      (exams: any, meta: any) => {
        setExams([...exams]);
        setExamsHolder([...exams]);
      },
      (error: any) => {}
    );
  };

  const handleSubmit = (values: any) => {
    setButtonLoading(true);
    if (data) {
      SectionService.updateSection(
        data?.id,
        values,
        () => {
          refreshList();
          closeHandler();
          setBranches([]);
          setBranchClassRooms([]);
          setExams([]);
          setSubjects([]);
          setSubjectsHolder([])
          formRef.current.resetForm(initialValues);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      );
    } else {
      SectionService.createSection(
        values,
        () => {
          refreshList();
          closeHandler();
          setBranches([]);
          setBranchClassRooms([]);
          setExams([]);
          setSubjects([]);
          setSubjectsHolder([])
          formRef.current.resetForm(initialValues);
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      );
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
      innerRef={formRef}
      validationSchema={SectionValidationSchema}
    >
      {({ values, setFieldValue, resetForm }) => (
        <UIModal
          visible={visible}
          closeModal={closeHandler}
          onClosed={() => {
            resetForm();
          }}
          submitProps={{
            text: data ? "Update" : "Create",
            buttonLoading: buttonLoading,
            clickHandler: () => {
              handleSubmit(values);
            },
          }}
          cancelProps={{
            text: "Cancel",
            clickHandler: () => {
              closeHandler();
            },
          }}
          className="institute-section-form__container"
        >
          <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <div className="institute-section-form__header">
              <div className="institute-section-form__title">
                {data ? "Update Section" : "Create New Section"}
              </div>
              <div className="institute-section-form__toggle">
                <Field name="isActive" as="switch">
                  <ToggleSwitch
                    checked={values?.isActive}
                    handleChange={(value) => {
                      setFieldValue("isActive", value);
                    }}
                  />
                </Field>
              </div>
            </div>

            <div className="institute-section-form__input">
              <div className="institute-section-form__label">Branch Name</div>
              <DropdownField
                name="branchId"
                placeholder="Select branch"
                options={branches}
                value={values?.branchId}
                onChange={(value) => {
                  setFieldValue("branchId", value);
                  setFieldValue("branchClassRoomId", undefined);
                  fetchClassRooms(value);
                }}
                showSearch={false}
                optionFilterProp="label"
              />
            </div>
            <div className="institute-section-form__input">
              <div className="institute-section-form__label">Class</div>
              <DropdownField
                name="branchClassRoomId"
                placeholder="Select class"
                options={branchClassRooms}
                value={values?.branchClassRoomId}
                onChange={(value, data) => {
                  setFieldValue("branchClassRoomId", value);

                  // remove hardcoded value
                  fetchSubjects(data?.id);
                }}
                showSearch={false}
                optionFilterProp="label"
              />
            </div>
            <div className="institute-section-form__input">
              <div className="institute-section-form__label">Section Name</div>
              <InputField
                type="text"
                name="name"
                placeholder="Type section name"
              />
            </div>
            <div className="institute-section-form__input">
              <div className="institute-section-form__label">
                Configure Subjects
              </div>
              <SearchInput
                placeholder={"Search"}
                onChange={(searchText) => {
                  let search = subjectsHolder?.filter(
                    (subject) =>
                      subject?.name
                        ?.toLowerCase()
                        ?.indexOf(searchText.toLowerCase()) > -1
                  );
                  setSubjects([...search]);
                }}
              />
              <div className="configure-subjects___wrapper">
                {subjects?.length ? (
                  <Row className="items__wrapper">
                    <Col span={24}>
                      <div className="configure-checkbox__wrapper">
                        <Checkbox
                          checked={
                            values?.sectionSubjects?.length == subjects?.length
                          }
                          onChange={(checked) => {
                            if (checked.target.checked) {
                              let selectAll = deserialize(
                                SectionSubjectMetaModel,
                                subjects
                              );
                              setFieldValue("sectionSubjects", [...selectAll]);
                            } else {
                              setFieldValue("sectionSubjects", []);
                            }
                          }}
                        >
                          Select all
                        </Checkbox>
                      </div>
                    </Col>
                    {subjects?.map((value, index) => {
                      return (
                        <Col span={24}>
                          <div className="configure-checkbox__wrapper">
                            <Checkbox
                              checked={
                                values?.sectionSubjects?.filter(
                                  (data) =>
                                    data?.classRoomSubjectId == value?.id
                                )?.length
                              }
                              onChange={(checked) => {
                                if (
                                  checked?.target?.checked &&
                                  !values?.sectionSubjects?.filter(
                                    (boardClass) =>
                                      boardClass?.classRoomSubjectId ==
                                      value?.id
                                  )?.length
                                ) {
                                  let subjects: any[] = values?.sectionSubjects;

                                  subjects?.push({
                                    classRoomSubjectId: value?.id,
                                  });

                                  setFieldValue("sectionSubjects", [
                                    ...subjects,
                                  ]);
                                } else if (
                                  !checked?.target?.checked &&
                                  values?.sectionSubjects?.filter(
                                    (boardClass) =>
                                      boardClass?.classRoomSubjectId ==
                                      value?.id
                                  )?.length
                                ) {
                                  let subjects =
                                    values?.sectionSubjects?.filter(
                                      (boardClass) =>
                                        boardClass?.classRoomSubjectId !==
                                        value?.id
                                    );
                                    console.log(subjects)
                                  setFieldValue("sectionSubjects", [
                                    ...subjects,
                                  ]);
                                } else {
                                  // do nothing
                                }
                              }}
                            >
                              {value?.subject?.displayPictureUrl ?
                              <span className="checkbox__icon">
                              <img src={value?.subject?.displayPictureUrl} />
                            </span> : ""
                              }

                              {value?.name}
                            </Checkbox>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                ) : (
                  <p className="no-data__text">No subjects</p>
                )}
              </div>
            </div>
            <div className="institute-section-form__input">
              <div className="institute-section-form__label">
                Configure Exams
              </div>
              <SearchInput
                placeholder={"Search"}
                onChange={(searchText) => {
                  let search = examsHolder?.filter(
                    (exam) => exam?.name?.indexOf(searchText) > -1
                  );
                  setExams([...search]);
                }}
              />
              <div className="configure-exams___wrapper">
                {exams?.length ? (
                  <Row className="items__wrapper">
                    <Col span={24}>
                      <div className="configure-checkbox__wrapper">
                        <Checkbox
                          checked={
                            values?.sectionExams?.length == exams?.length
                          }
                          onChange={(checked) => {
                            if (checked.target.checked) {
                              let selectAll = deserialize(
                                SectionExamMetaModel,
                                exams
                              );
                              setFieldValue("sectionExams", [...selectAll]);
                            } else {
                              setFieldValue("sectionExams", []);
                            }
                          }}
                        >
                          Select all
                        </Checkbox>
                      </div>
                    </Col>
                    {exams?.map((value, index) => {
                      return (
                        <Col span={24}>
                          <div className="configure-checkbox__wrapper">
                            <Checkbox
                              checked={
                                values?.sectionExams?.filter(
                                  (data) => data?.examId == value?.id
                                )?.length
                              }
                              onChange={(checked) => {
                                if (
                                  checked?.target?.checked &&
                                  !values?.sectionExams?.filter(
                                    (exam) => exam?.examId == value?.id
                                  )?.length
                                ) {
                                  let exams: any[] = values?.sectionExams;

                                  exams?.push({
                                    examId: value?.id,
                                  });

                                  setFieldValue("sectionExams", [...exams]);
                                } else if (
                                  !checked?.target?.checked &&
                                  values?.sectionExams?.filter(
                                    (exam) => exam?.examId == value?.id
                                  )?.length
                                ) {
                                  let exams = values?.sectionExams?.filter(
                                    (exam) => exam?.examId !== value?.id
                                  );
                                  setFieldValue("sectionExams", [...exams]);
                                } else {
                                  // do nothing
                                }
                              }}
                            >
                              {
                                value?.displayPictureUrl ?
                                <span className="checkbox__icon">
                                <img src={value?.displayPictureUrl} />
                              </span> : ""
                              }

                              {value?.name}
                            </Checkbox>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                ) : (
                  <p className="no-data__text">No exams</p>
                )}
              </div>
            </div>
          </Form>
        </UIModal>
      )}
    </Formik>
  );
};

export default InstituteSectionForm;
